"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var pay_api_1 = require("@l2p/pay-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var MethodImage_1 = __importDefault(require("./Method/MethodImage"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Methods = function () {
    var _a, _b, _c, _d, _e;
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var _f = (0, react_1.useState)('deposit'), type = _f[0], setType = _f[1];
    var _g = (0, react_1.useState)(''), search = _g[0], setSearch = _g[1];
    var _h = (0, react_1.useState)(''), category = _h[0], setCategory = _h[1];
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setSearch(target.value);
    }, []);
    var onSearchClear = (0, react_1.useCallback)(function () {
        setSearch('');
    }, []);
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var onButtonClick = (0, react_1.useCallback)(function (methodId) {
        if (isAuth)
            openDeposit("methodId=".concat(methodId));
        else
            openSignUp();
    }, [isAuth, openDeposit, openSignUp]);
    var _j = (0, swr_hooks_1.usePublicPayInMethods)(), payInPublicData = _j.data, payInPublicLoading = _j.isLoading;
    var _k = (0, swr_hooks_1.usePayInMethodsProfile)(), payInProfileData = _k.data, payInProfileLoading = _k.isLoading;
    var payInData = isAuth
        ? ((_b = (_a = payInProfileData === null || payInProfileData === void 0 ? void 0 : payInProfileData.payIn) === null || _a === void 0 ? void 0 : _a.getMethods) === null || _b === void 0 ? void 0 : _b.edges) || []
        : (((_d = (_c = payInPublicData === null || payInPublicData === void 0 ? void 0 : payInPublicData.payInPublic) === null || _c === void 0 ? void 0 : _c.getMethods) === null || _d === void 0 ? void 0 : _d.edges) ||
            []);
    var payInLoading = isAuth ? payInProfileLoading : payInPublicLoading;
    // const { data: withdrawalData, isLoading: withdrawalLoading } =
    //   useWithdrawalMethods()
    var CATEGORIES_MAP = (0, react_1.useMemo)(function () { return ({
        all: { id: '', title: t('byCategories') },
        cards: { id: 'cards', title: t('cards') },
        'bank-transfer': { id: 'bank-transfer', title: t('bankTransfers') },
        'payment-systems': { id: 'payment-systems', title: t('paymentSystems') },
        crypto: { id: 'crypto', title: t('crypto') },
        vouchers: { id: 'vouchers', title: t('vouchers') },
    }); }, [t]);
    var categotiesOptions = Object.values(CATEGORIES_MAP).filter(function (c) {
        return payInData === null || payInData === void 0 ? void 0 : payInData.find(function (m) { return (m === null || m === void 0 ? void 0 : m.category) === (c === null || c === void 0 ? void 0 : c.id) || (c === null || c === void 0 ? void 0 : c.id) === ''; });
    });
    var preparedPayInMethods = function (methods) {
        return methods === null || methods === void 0 ? void 0 : methods.map(function (m) {
            var _a, _b, _c, _d, _e, _f;
            var minConstraint = (_a = m === null || m === void 0 ? void 0 : m.constraints) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.type === pay_api_1.PayInConstraintType.MinTransaction; });
            var maxConstraint = (_b = m === null || m === void 0 ? void 0 : m.constraints) === null || _b === void 0 ? void 0 : _b.find(function (c) { return c.type === pay_api_1.PayInConstraintType.MaxTransaction; });
            var min = ((_d = (_c = minConstraint === null || minConstraint === void 0 ? void 0 : minConstraint.minTransaction) === null || _c === void 0 ? void 0 : _c.find(function (t) { return t.currency === currentCurrency; })) === null || _d === void 0 ? void 0 : _d.amount) || '0';
            var max = ((_f = (_e = maxConstraint === null || maxConstraint === void 0 ? void 0 : maxConstraint.maxTransaction) === null || _e === void 0 ? void 0 : _e.find(function (t) { return t.currency === currentCurrency; })) === null || _f === void 0 ? void 0 : _f.amount) || '10000';
            return __assign(__assign({}, m), { category: CATEGORIES_MAP[m.category].title, categoryId: CATEGORIES_MAP[m.category].id, min: "".concat(t('min'), " ").concat(min, " ").concat(currentCurrency), max: "".concat(t('max'), " ").concat(max, " ").concat(currentCurrency), minMax: "".concat(min, " - ").concat(max, " ").concat(currentCurrency) });
        });
    };
    var methods = type === 'deposit' ? preparedPayInMethods(payInData) || [] : [];
    var filterIndexMap = (0, react_1.useMemo)(function () {
        var map = {};
        Object.values(CATEGORIES_MAP).forEach(function (filter, index) {
            map[filter.title] = index;
        });
        return map;
    }, [CATEGORIES_MAP]);
    var sortedMethods = Array.from(new Set(methods)).sort(function (a, b) {
        var indexA = filterIndexMap[String(a.category)] !== undefined
            ? filterIndexMap[String(a.category)]
            : Infinity;
        var indexB = filterIndexMap[String(b.category)] !== undefined
            ? filterIndexMap[String(b.category)]
            : Infinity;
        return indexA - indexB;
    });
    var methodsWithSearch = sortedMethods === null || sortedMethods === void 0 ? void 0 : sortedMethods.filter(function (m) {
        var _a;
        if (!category) {
            return m;
        }
        else {
            return ((_a = m.categoryId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === category.toLowerCase();
        }
    }).filter(function (m) { var _a; return (_a = m === null || m === void 0 ? void 0 : m.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase()); });
    if (payInLoading)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
            react_1.default.createElement(ui_components_1.LoadingSpinner, null)));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('paymentsPageTitle'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filters },
                react_1.default.createElement(ui_components_1.SearchInput, { withClear: false, value: search, onChange: onSearchChange, onClear: onSearchClear, placeholder: "translation.enterNameOfMethod" }),
                react_1.default.createElement(Dropdown_1.default, { title: "By Categories", value: (_e = categotiesOptions === null || categotiesOptions === void 0 ? void 0 : categotiesOptions.find(function (c) { return (c === null || c === void 0 ? void 0 : c.id) === category; })) === null || _e === void 0 ? void 0 : _e.title, onChange: setCategory, options: categotiesOptions })),
            Object.keys(breakpoints).length > 0 &&
                !(breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.methods },
                react_1.default.createElement("table", null,
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("td", null),
                        react_1.default.createElement("td", null, t('paymentsPageMethod')),
                        react_1.default.createElement("td", null, t('paymentsPageCategory')),
                        react_1.default.createElement("td", null, t('paymentsPageFee')),
                        react_1.default.createElement("td", null, t('paymentsPageMinLimit')),
                        react_1.default.createElement("td", null, t('paymentsPageMaxLimit')),
                        react_1.default.createElement("td", null)),
                    react_1.default.createElement("tbody", null, methodsWithSearch === null || methodsWithSearch === void 0 ? void 0 : methodsWithSearch.map(function (m, idx) { return (react_1.default.createElement("tr", { key: "method_".concat(m.name, "_").concat(idx) },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(MethodImage_1.default, __assign({}, m))),
                        react_1.default.createElement("td", null, m.name),
                        react_1.default.createElement("td", null, m.category),
                        react_1.default.createElement("td", { className: styles_module_scss_1.default.free }, t('paymentsPageFree')),
                        react_1.default.createElement("td", null, m.min),
                        react_1.default.createElement("td", null, m.max),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(ui_components_1.FixedButton, { onClick: function () { return onButtonClick(m.id); } }, t('deposit'))))); }))))),
            Object.keys(breakpoints).length > 0 &&
                (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.methodsMobile }, methodsWithSearch === null || methodsWithSearch === void 0 ? void 0 : methodsWithSearch.map(function (m, idx) { return (react_1.default.createElement("div", { className: styles_module_scss_1.default.methodMobile, key: "method_".concat(m.name, "_").concat(idx) },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(MethodImage_1.default, __assign({}, m)),
                    react_1.default.createElement("span", null, m.name)),
                react_1.default.createElement("table", null,
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("td", null, t('paymentsPageMethod')),
                        react_1.default.createElement("td", null, t('paymentsPageFee')),
                        react_1.default.createElement("td", null, t('paymentsPageLimit'))),
                    react_1.default.createElement("tbody", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", null, m.category),
                            react_1.default.createElement("td", { className: styles_module_scss_1.default.free }, t('paymentsPageFree')),
                            react_1.default.createElement("td", null, m.minMax)))),
                react_1.default.createElement(ui_components_1.FixedButton, { width: "100%", maxWidth: "100%", onClick: function () { return onButtonClick(m.id); } }, t('deposit')))); }))))));
};
exports.default = Methods;
